import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const Portal = ({ Component, htmlRoot }: { Component: React.ReactNode; htmlRoot: string }) => {
  const [HTMLRootElement, setHTMLRootElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const element = document.querySelector(`[data-react-root=${htmlRoot}]`);
    if (element && element instanceof HTMLElement) {
      setHTMLRootElement(element);
    }
  }, []);

  if (!HTMLRootElement) return null;

  return createPortal(Component, HTMLRootElement);
};

export default Portal;
